const settle = {
  'settle.title': 'Settlement',
  'settle.goSettle': 'Proceed to Settlement',
  'settle.productInfo': 'Product Information',
  'settle.table.column.index': 'Index',
  'settle.table.column.image': 'Product Image',
  'settle.table.column.detail': 'Parts Details',
  'settle.table.column.replaceNumber': 'Replacement Number',
  'settle.table.column.price': 'Price',
  'settle.table.column.quantity': 'Quantity',
  'settle.selected': '{count} items selected',
  'settle.totalQuantity': 'Total Quantity: {quantity} items',
  'settle.goToOrder': 'Place Order',

  'settle.deliveryMethod': 'Delivery Requirement',
  'settle.deliveryMethod.placeholder': 'Please select delivery requirement',
  'settle.deliveryMethod.normal': 'Standard',
  'settle.deliveryMethod.normal.desc': 'General land transportation channels',
  'settle.deliveryMethod.urgent': 'Expedited',
  'settle.deliveryMethod.urgent.desc':
    'Expedited order will be processed and arranged for air shipment first, with faster delivery time and higher cost',

  // Form validation and operation messages
  'settle.form.validation.error': 'Please check form input fields',
  'settle.address.required': 'Please select a delivery address',
  'settle.product.required': 'Please select at least one product',
  'settle.order.submitting': 'Placing order...',
  'settle.order.success': 'Order placed successfully',
  'settle.order.failed': 'Order failed',
  'settle.order.retry': 'Order failed, please try again',

  'settle.message.invalidSelectedProducts':
    'Some commodity quantities do not meet the requirements, please check',

  'settle.order.failedModal.title':
    'Order failed, the quantity of products in the table does not meet the requirements',
  'settle.order.failedModal.content':
    'The quantity of products must be greater than the minimum quantity and a multiple of the multiple sale quantity. Please modify the order quantity and try again.',
  'settle.order.failedModal.product': 'Product Name',
  'settle.order.failedModal.quantity': 'Current Quantity',
  'settle.order.failedModal.min_sale_count': 'Minimum Quantity',
  'settle.order.failedModal.multiple_sale_count': 'Multiple Sale Quantity',
  'settle.order.failedModal.error_message': 'Error Message',
};

export default settle;
